import employee from './employee'
import itemGroup from './item-group'
import itemCategory from './item-category'
import itemType from './item-type'
import load from './load'
import packagge from './package'
import packageTypes from './package-types'
import soil from './soil'
import addon from './addon'
import loadCondition from './load-condition'

export default {
  name: 'BaseInfoOrderProperty',
  path: 'order-properties',
  meta: {
    label: 'shipmentDetails',
    auth: 'property'
  },
  component: {
    name: 'OrderProperty',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    employee,
    itemGroup,
    itemCategory,
    itemType,
    load,
    packagge,
    packageTypes,
    soil,
    addon,
    loadCondition
  ]
}
